export default __webpack_public_path__ + "static/media/saveOutlineColorIcon.727b3896.svg";